import namespace from "@rdf-esm/namespace";
const builder = namespace("http://www.w3.org/2002/07/owl#");
export const strict = builder;
export const loose = builder;